import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';

export default class Commands extends React.Component {
    render() {
        const { commands } = this.props;
        const isMobile = typeof window !== 'undefined' && window.innerWidth <= 480;

        return (
            <div className="commands">
                {commands.map(({ command, caption, color, foreground, disabled}) =>
                    <RaisedButton
                        className="commandButton"
                        key={caption}
                        label={caption}
                        labelColor={foreground}
                        backgroundColor={color}
                        onClick={command}
                        disabled={disabled === true}
                        labelStyle={isMobile ? {
                            fontSize: '11px',
                            paddingLeft: '4px',
                            paddingRight: '4px'
                        } : {}}
                    >
                    </RaisedButton>
                )}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/Commands.jsx